import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CheckUserAuth from 'components/auth/CheckUserAuth';
import LightLayout from 'components/layout/LightLayout';
import MainLayout from 'components/layout/MainLayout';
import Patients from 'routes/patients/Patients';
import NewAccount from 'routes/auth/NewAccount';
import NotFound from 'routes/notfound/NotFound';
import Patient from 'routes/patients/Patient';
import Account from 'routes/account/Account';
import Agenda from 'routes/agenda/Agenda';
import SignIn from 'routes/auth/SignIn';
import Admin from 'routes/admin/Admin';
import AdminAsDoctorAgenda from './admin/AdminAsDoctorAgenda';

export default function Router() {
  useEffect(() => {
    const head = document.querySelector('head');
    if (!head) {
      return;
    }

    let tailWindStyleTag = Array.from(head.getElementsByTagName('style'))
      .find((style) => style.innerHTML.includes('tailwind'));

    if (!tailWindStyleTag) {
      tailWindStyleTag = Array.from(head.getElementsByTagName('link'))
        .find((link) => link.href.includes('css/main'));
    }

    if (tailWindStyleTag) {
      head.insertAdjacentElement('afterbegin', tailWindStyleTag);
    }
  }, []);

  return (
    <BrowserRouter>
      <CheckUserAuth />
      <Routes>
        <Route element={<MainLayout />}>
          <Route
            element={<Agenda />}
            path='/'
          />
          <Route
            element={<Patients />}
            path='/patients'
          />
          <Route
            element={<Patient />}
            path='/patients/:patientID'
          />
          <Route
            element={<Account />}
            path='/account'
          />
          <Route
            element={<Admin />}
            path='/admin'
          />
          <Route
            element={<AdminAsDoctorAgenda />}
            path='/admin/agenda/:doctorID'
          />
        </Route>
        <Route element={<LightLayout />}>
          <Route
            element={<SignIn />}
            path='/sign-in'
          />
          <Route
            element={<NewAccount />}
            path='/new-account'
          />
          <Route
            element={<NotFound />}
            path='*'
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
